export default class CountryData {
    public id: number;
    public languageId: number;
    public currencyId: number;
    public localName: string;
    public englishName: string;
    public languageKey: string;

    constructor(
        id: number,
        languageId: number = null,
        currencyId: number = null,
        localName: string = '',
        englishName: string = '',
        languageKey: string = 'en',
    ) {
        this.id = id;
        this.languageId = languageId;
        this.currencyId = currencyId;
        this.localName = localName;
        this.englishName = englishName;
        this.languageKey = languageKey;
    }
}
